<template>
  <v-dialog :value="value" @input="closeDialog" fullscreen dark persistent transition="fade-transition">
    <v-card style="background-color: rgba(0, 0, 0, 0.9); backdrop-filter: blur(10px)" flat class="d-flex flex-column fill-height pa-4">
      <v-toolbar class="align-self-end" dark color="transparent" flat>
        <v-btn icon large @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="flex-grow-1 d-flex justify-center align-center pa-0">
        <template v-if="isImageVideoAudio && localPreviewUrl">
          <v-img v-if="fileType.startsWith('image/')" :src="localPreviewUrl" contain class="media-preview-content" />
          <video v-if="fileType.startsWith('video/')" :src="localPreviewUrl" controls class="media-preview-content" />
          <audio v-if="fileType.startsWith('audio/')" :src="localPreviewUrl" controls class="media-preview-content" />
        </template>
        <template v-else>
          <v-sheet color="grey darken-3" rounded="xl" class="pa-8 d-flex flex-column align-center">
            <v-icon size="100" color="grey lighten-1">mdi-file-document-outline</v-icon>
            <span class="headline mt-4">{{ file.name }}</span>
            <span class="caption grey--text">{{ (file.size / 1024).toFixed(0) }} KB</span>
          </v-sheet>
        </template>
      </v-card-text>

      <v-card-actions class="pa-0">
        <v-sheet dark class="message-input-area pa-2" elevation="4" color="grey darken-3" style="width: 100%">
          <v-text-field
            v-model="textContent"
            placeholder="Beschriftung hinzufügen..."
            filled
            rounded
            dense
            style="align-items: center !important"
            hide-details
            dark
            autocomplete="off">
            <template v-slot:append-outer>
              <v-btn style="margin: auto !important" fab small depressed color="primary" :loading="isLoading" @click="sendFile">
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-sheet>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// (Wir brauchen Axios und die Gruppen-ID)
import axios from "axios"
import { mapState } from "vuex"

export default {
  name: "SendMediaPreviewDialog",
  props: {
    value: Boolean, // v-model
    file: {
      // Die rohe Datei vom <input>
      type: File,
      default: null,
    },
  },
  data() {
    return {
      textContent: "", // Die Beschriftung
      localPreviewUrl: null, // Die lokale Blob-URL
      fileType: "",
      isImageVideoAudio: false,
      isLoading: false, // Lade-Status für Senden-Button
    }
  },
  computed: {
    ...mapState("chatStore", ["activeGroupId"]),
  },
  watch: {
    // Wenn die 'file'-Prop reinkommt, erstelle eine lokale Vorschau-URL
    file: {
      handler(newFile) {
        if (newFile) {
          // Alte URL freigeben, um Memory-Leaks zu verhindern
          if (this.localPreviewUrl) {
            URL.revokeObjectURL(this.localPreviewUrl)
          }
          // Neue lokale URL erstellen
          this.localPreviewUrl = URL.createObjectURL(newFile)
          this.fileType = newFile.type
          this.isImageVideoAudio = newFile.type.startsWith("image/") || newFile.type.startsWith("video/") || newFile.type.startsWith("audio/")
        }
      },
      immediate: true, // Sofort ausführen, wenn der Dialog geladen wird
    },
  },
  methods: {
    closeDialog() {
      // Nur schließen, wenn wir nicht gerade laden
      if (this.isLoading) return
      this.$emit("input", false)
    },

    async sendFile() {
      if (!this.file || !this.activeGroupId) return

      this.isLoading = true

      // 1. FormData (genau wie vorher in chatMessageView)
      const formData = new FormData()
      formData.append("file", this.file)

      // 2. JETZT MIT TEXT-INHALT (aus dem Backend-Fix)
      formData.append("textContent", this.textContent)

      try {
        const token = localStorage.getItem("token")
        await axios.post(`/api/chat/groups/${this.activeGroupId}/media`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        })
        // Erfolg! Schließe den Dialog (Socket-Event macht den Rest)
        this.isLoading = false
        this.closeDialog()
      } catch (err) {
        console.error("Fehler beim Datei-Upload:", err)
        // this.$toast.error("Upload fehlgeschlagen");
        this.isLoading = false
      }
    },
  },
  beforeDestroy() {
    // WICHTIG: Letzte lokale URL freigeben, wenn Komponente zerstört wird
    if (this.localPreviewUrl) {
      URL.revokeObjectURL(this.localPreviewUrl)
    }
  },
}
</script>

<style lang="scss" scoped>
.media-preview-content {
  max-width: 90vw;
  max-height: 70vh;
  border-radius: 8px;
}
.message-input-area {
  border-radius: 28px !important;
}
</style>
